import React from "react";
import {connect} from "react-redux";
import {View, Text, StyleSheet, TouchableOpacity} from "react-native";
import CheckActivePicto from "../../Picto/CheckActivePicto";
import FermerPicto from "../../Picto/FermerPicto";
import AvatarIcon from "../../Header/AvatarIcon";
import CheckNotActivePicto from "../../Picto/CheckNotActivePicto";


class SharePostItem extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            selected : this.props.selected,
        }
    }



    render() {
        const styles = StyleSheet.create({
            container : {
                flexDirection : "row",
                paddingVertical:22,
                paddingLeft:15,
                alignItems:"center"
            },
            containerLabel : {
                width:"70%",
                display:"flex",
                justifyContent:"center"
            },
            label : {
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"600",
                fontSize:15,
                color: this.props.theme.colors.tertiary.black1.value,
            },
            contactContainer : {

            }
        });

        const contact = this.props.contact;
        const isSelected = this.props.selected.includes(contact.id);
        return (<View>
                <TouchableOpacity style={styles.contactContainer}
                                  onPress={()=>{this.setState({});this.props.setSelectedValue(contact.id,!isSelected)}}>
                        <View style={styles.container}>
                        <AvatarIcon style={{width: 40,height:40,marginRight:10,borderRadius: 13}} icon={contact.img}/>
                        <View style={styles.containerLabel}><Text style={styles.label}>{contact.firstname} {contact.lastname}</Text></View>
                        { isSelected && <View ><CheckActivePicto isHeader={true} style={{width:24,height:24}} /></View> }{ this.props.value === this.props.timeParution && <View ><CheckActivePicto isHeader={true} style={{width:24,height:24}} /></View> }
                        { !isSelected && <View ><CheckNotActivePicto isHeader={true} style={{width:24,height:24}} /></View> }
                    </View>
                </TouchableOpacity>
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer,timeParution:state.tendanceReducer.timeParution};
}

export default connect(mapStateToProps)(SharePostItem);
